import React from 'react';

import { Paragraph, Typography } from '../../designComponents';
import Timeline from '../../designComponents/Timeline';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { ContractDetailsContainerStyled } from './style';

type Props = {};

const ContractDetail = (_props: Props) => {
  const events = [
    {
      date: '11 August 2023',
      title: 'Starting Date',
    },
    {
      date: '11 August 2023',
      title: 'End Date',
    },
    //
  ];
  return (
    <ContractDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        CONTRACT DETAILS
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Timeline :</Typography>
          {/* <Typography className="value">Kathmandu Mall</Typography> */}
          <Timeline events={events} />
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title">Specification :</Typography>

          <Paragraph
            className="value"
            fontColor="primary"
            text=" Lorem ipsum dolor sit amet consectetur. Mi ultricies mollis magna
            cursus libero. Lacus sodales gravida vulputate id suspendisse magna
            iaculis. Eget et et enim facilisi amet ac eget. Faucibus gravida
            risus massa aliquam vitae. Adipiscing pretium dignissim vestibulum
            non netus ultricies. Morbi sit sed sed vulputate pretium dolor
            dictum eget."
          />
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Experience :</Typography>

          <Typography className="value">1 Year</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Cost Estimation :</Typography>

          <Typography className="value">€ 199 </Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Work Approach :</Typography>

          <Typography className="value">Onsite Assessment</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">
            Risk Assessment :
          </Typography>

          <Typography className="value">Based on Building Layout</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title">Design Approach :</Typography>

          <Paragraph
            className="value"
            fontColor="primary"
            text="Lorem ipsum dolor sit amet consectetur. Mi ultricies mollis magna
            cursus libero. Lacus sodales gravida vulputate id suspendisse magna
            iaculis. Eget et et enim facilisi amet ac eget. Faucibus gravida
            risus massa aliquam vitae. Adipiscing pretium dignissim vestibulum
            non netus ultricies. Morbi sit sed sed vulputate pretium dolor
            dictum eget."
          />
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ContractDetailsContainerStyled>
  );
};

export default ContractDetail;
